import { adminStyles } from "../styles/admin.styles";
import { Outlet } from "react-router-dom";
import { twMerge } from "tailwind-merge";

// Sidebar links select the scan; each dedicated scan page owns its reader lifecycle.
const AdminAiScansPage = () => (
  <main
    data-test="admin-ai-scans-page"
    className={twMerge(adminStyles.page.pagePadding, "h-full min-w-0 flex-1 space-y-3 overflow-y-auto py-4")}
  >
    <header data-test="admin-ai-scans-header">
      <h1 className="text-xl font-semibold">AI Scans</h1>
    </header>
    <Outlet />
  </main>
);

export default AdminAiScansPage;
